export default "__VITE_ASSET__DIVfmH$e__"